import type { ReactNode } from 'react';

/**
 * The frame both Feature Activation pages share, as the design draws it.
 *
 * - **Width.** The design's `<main>` is `max-width: 1320px` with 36px of
 *   padding, so its content never grows past 1248px and sits to the left on a
 *   wide screen. The app's `<main>` is shared by every screen and has no cap,
 *   so the cap lives here, on these two pages only, and measures the content
 *   (1320 − 2 × 36) rather than the box.
 * - **Title.** 28px in the design; the kit's `PageHeader` is 24px for every
 *   other screen and takes no `className`. The size is applied from here to
 *   whatever `<h1>` the page renders, so `PageHeader` keeps its eyebrow and
 *   description untouched.
 */
export function ActivationPageFrame({ children }: { children: ReactNode }) {
    return <div className="max-w-[1248px] [&_h1]:text-[28px] [&_h1]:leading-9">{children}</div>;
}
